'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { Button } from '@/app/[locale]/(ui)/button'

const ErrorPage = () => {
  const t = useTranslations()

  return (
    <div className="mx-auto flex w-full max-w-screen-md flex-col items-center gap-8 px-8 py-20 text-center">
      <div className="space-y-4">
        <h1 className="text-4xl font-bold sm:text-5xl">{t('Error_page_heading')}</h1>
        <p className="text-lg">
          {t('Error_page_description')} {t('Error_page_contact_support')}.
        </p>
      </div>
      <div className="relative aspect-video w-full overflow-hidden rounded-xl">
        <Image
          src="/404.jpg"
          alt=""
          className="object-cover"
          fill
          sizes="(min-width: 768px) 768px, 100vw"
          loading="eager"
        />
      </div>
      <Button variant="primary" className="text-lg" href="/kundeservice">
        {t('Error_page_contact_support_button')}
      </Button>
    </div>
  )
}

export default ErrorPage
